import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { TranslateLoader } from '@ngx-translate/core';

export class TranslateBrowserLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private basePath = 'opts'
  ) {}

  getTranslation(lang: string): Observable<any> {
    return this.http.get(`${this.basePath}/${lang}/translations/ang.json`);
  }
}
